import { render } from "./SpmMessage.vue?vue&type=template&id=fd21cdd0&scoped=true"
import script from "./SpmMessage.vue?vue&type=script&lang=ts"
export * from "./SpmMessage.vue?vue&type=script&lang=ts"

import "./SpmMessage.vue?vue&type=style&index=0&id=fd21cdd0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-fd21cdd0"

export default script